import {SortOrder} from '../../../../../../core/rest-client/aat';
import {TableSortingState} from '../../../../../../common/model/types/sorting/TableSortingState';
import {ServerSortingConfig} from '../DefaultTable';

/**
 * Translates the sorting state kept by a controller into the configuration expected by
 * {@link DefaultTable} and converts the reported change back into API values.
 *
 * @param defaultSortBy key of the column the server orders by when no order is requested,
 * so that the table shows the actual order of the rows from the very first render
 */
export function toServerSortingConfig(state: TableSortingState | undefined,
    onChange: (sortBy?: string, sortOrder?: SortOrder) => void | Promise<unknown>,
    defaultSortBy?: string): ServerSortingConfig | undefined {
    if (!state) {
        return undefined;
    }

    const sortBy = state.sortBy ?? defaultSortBy;

    return {
        sortBy,
        sortDirection: state.sortOrder === SortOrder.Desc
            ? 'desc'
            : sortBy ? 'asc' : undefined,
        onSortChange: (sortBy, sortDirection) => onChange(
            sortBy,
            sortDirection === 'desc' ? SortOrder.Desc : sortDirection ? SortOrder.Asc : undefined
        )
    };
}
